<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" @opened="openFun" width="400px">
    <el-form :model="userAimForm" label-width="120px">
      <el-form-item label="月度目标" prop="month">
        <el-input-number v-model="userAimForm.months" :min="0" placeholder="请输入月度目标"></el-input-number>
      </el-form-item>
      <el-form-item label="第一季度目标" prop="unit1">
        <el-input-number v-model="userAimForm.unit1" :min="0" placeholder="请输入目标"></el-input-number>
      </el-form-item>
      <el-form-item label="第二季度目标" prop="unit2">
        <el-input-number v-model="userAimForm.unit2" :min="0" placeholder="请输入目标"></el-input-number>
      </el-form-item>
      <el-form-item label="第三季度目标" prop="unit3">
        <el-input-number v-model="userAimForm.unit3" :min="0" placeholder="请输入目标"></el-input-number>
      </el-form-item>
      <el-form-item label="第四季度目标" prop="unit4">
        <el-input-number v-model="userAimForm.unit4" :min="0" placeholder="请输入目标"></el-input-number>
      </el-form-item>
      <el-form-item label="年度目标" prop="year">
        <el-input-number v-model="userAimForm.year" :min="0" placeholder="请输入目标"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="closeDialog">关闭</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitUser">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {saveUserAim, getUserAim} from "../../../api/sys/user/sysUser";
import {errorMsg, successMsg} from "@/utils/message";

export default {
  name: "Achievement",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    username: {
      type: String,
      require: true
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      title: '设置',
      isLoading: false,
      userAimForm: {},
    }
  },
  methods: {
    openFun: function () {
      const defaultForm = {
        id: null,
        username: this.username,
        months: 0,
        year: 0,
        unit1: 0,
        unit2: 0,
        unit3: 0,
        unit4: 0
      };
      getUserAim(this.username).then(res => {
        this.userAimForm = { ...defaultForm, ...res };
      });
    },
    closeDialog() {
      this.visible = false
    },
    submitUser() {
      saveUserAim(this.userAimForm).then(() => {
        successMsg('操作成功')
        this.visible = false
        this.$emit('get-list')
      })
      .catch(() => {
        errorMsg('操作失败')
        this.visible = false
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
  }
}
</script>

<style scoped>

.el-dialog {
  width: 400px;
  margin: 0 auto !important;
  transform: translateY(50%) !important;
}
</style>